/**
 * Virgin CPR Engine (§6)
 *
 * A Virgin CPR is a previous session's CPR zone that price never entered.
 * Detection is monotonic: status may only move VIRGIN → MITIGATED, never
 * back, so the display never repaints. Touches on the forming (live) bar
 * update the status dynamically (explicitly desired by the spec), while
 * alert events are only emitted for touches confirmed on a CLOSED bar.
 *
 * Touch = any candle overlapping the zone: high >= bottom && low <= top.
 */

import { CandleData } from "../../../types/chart.types";
import { SessionAgg, VirginState } from "./types";

export interface VirginStatus {
  state: VirginState;
  /** first touch bar across sessions after the CPR's origin session */
  firstTouch: { idx: number; time: number; closed: boolean } | null;
}

/**
 * @param originIdx index (into sessions) of the session the CPR came from
 * @param lastClosedIdx index of the last CLOSED candle (n-2 when n>=2)
 */
export const virginCprStatus = (
  candles: CandleData[],
  sessions: SessionAgg[],
  originIdx: number,
  top: number,
  bottom: number,
  lastClosedIdx: number,
): VirginStatus => {
  const origin = sessions[originIdx];
  if (!origin) return { state: "N/A", firstTouch: null };

  for (let i = origin.lastIdx + 1; i < candles.length; i++) {
    const c = candles[i];
    if (c.high >= bottom && c.low <= top) {
      return {
        state: "MITIGATED",
        firstTouch: { idx: i, time: c.time, closed: i <= lastClosedIdx },
      };
    }
  }
  return { state: "VIRGIN", firstTouch: null };
};
